/**
 * Shared axios client for every Heritage HQ page. Reads the customer JWT from
 * localStorage and bounces unauthorised responses back to /account/login.
 */
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const customerApi = axios.create({ baseURL: API, withCredentials: true });

customerApi.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("heritage-customer-token");
  if (tok && !cfg._skipCustomerToken && !cfg.headers?.Authorization) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

customerApi.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config;
    if (err?.response?.status === 401 && cfg && !cfg._customerCookieRetry) {
      cfg._customerCookieRetry = true;
      cfg._skipCustomerToken = true;
      if (cfg.headers) delete cfg.headers.Authorization;
      return customerApi(cfg);
    }
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/account/login")) {
      localStorage.removeItem("heritage-customer-token");
      window.location.href = "/account/login";
    }
    return Promise.reject(err);
  },
);

export default customerApi;
export { API };
